import Mixins from './mixins'

const Library = {
  install (Vue) {
    Vue.mixin(Mixins)
  }
}
export default Library
